import { initializeApp } from "firebase/app";
import {
    GoogleAuthProvider,
    getAuth,
    signInWithPopup,
    signInWithEmailAndPassword,
    createUserWithEmailAndPassword,
    sendPasswordResetEmail,
    signOut,
} from "firebase/auth";
import {
    getFirestore,
    query,
    getDocs,
    collection,
    where,
    addDoc,
} from "firebase/firestore";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyAWhnqxrg2D76Ww3cPF0fN0saGRKmUaFEw",
    authDomain: "rmu-pnta-atlas.firebaseapp.com",
    databaseURL: "https://rmu-pnta-atlas-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "rmu-pnta-atlas",
    storageBucket: "rmu-pnta-atlas.appspot.com",
    messagingSenderId: "638085368688",
    appId: "1:638085368688:web:de6125edf6573458d89db5",
    measurementId: "G-MPF6N1E5T9"
};

// app initialization
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

// Login functions
const logInWithEmailAndPassword = async (email, password) => {
    try {
        await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
        console.error(err);
        alert(err.message);
    }
};

// password reset
const sendPasswordReset = async (email) => {
    try {
        await sendPasswordResetEmail(auth, email);
        alert("Password reset link sent!");
    } catch (err) {
        console.error(err);
        alert(err.message);
    }
};

// logout
const logout = () => {
    signOut(auth);
};

export {
    auth,
    db,
    logInWithEmailAndPassword,
    sendPasswordReset,
    logout,
};